import React, { useEffect, useState } from 'react';
import './UpdateAvailableBanner.css';

function UpdateAvailableBanner({ registration, onDismiss }) {
  const [visible, setVisible] = useState(Boolean(registration));

  useEffect(() => {
    setVisible(Boolean(registration));
  }, [registration]);

  if (!visible || !registration?.waiting) {
    return null;
  }

  const handleUpdate = () => {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    window.location.reload();
  };

  return (
    <div className="update-banner" role="status">
      <p>A new version of TruthBound is available.</p>
      <div className="update-banner-actions">
        <button type="button" className="btn btn-primary btn-sm" onClick={handleUpdate}>
          Update
        </button>
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          onClick={() => {
            setVisible(false);
            onDismiss?.();
          }}
        >
          Later
        </button>
      </div>
    </div>
  );
}

export default UpdateAvailableBanner;